<template>
 <div>
   <nav aria-label="Page navigation">
     <ul class="pagination">
       <li v-if="pagination.pages.current != 1">
         <a href="#" @click.prevent="changePage(pagination.pages.current - 1)" aria-label="Previous">
           <span aria-hidden="true">&laquo;</span>
         </a>
       </li>
       <li v-else class="disabled">
         <a href="#" @click.prevent aria-label="Previous">
           <span>&laquo;</span>
         </a>
       </li>
       <li v-for="(page, key) in pagination.pages.total" :class="{ active: (page == pagination.pages.current) }">
         <a href="#" @click.prevent="changePage(key + 1)">{{ key + 1 }}</a>
       </li>
       <!--<li class="disabled"><a>...</a></li>-->
       <li v-if="pagination.pages.current != pagination.pages.total">
         <a href="#" @click.prevent="changePage(pagination.pages.current + 1)" aria-label="Next">
           <span aria-hidden="true">&raquo;</span>
         </a>
       </li>
       <li v-else class="disabled">
         <a href="#" @click.prevent aria-label="Next">
           <span aria-hidden="true">&raquo;</span>
         </a>
       </li>
     </ul>
   </nav>
 </div>
</template>

<script>
  export default {

    props: {
      pagination: {
        type: Object,
        required: true
      }
    },

    methods: {

      changePage (page) {
        this.pagination.pages.current = page
      }

    }

  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/etablissements/Pagination.vue